export var ResourceType;
(function (ResourceType) {
    ResourceType["ORGANIZATION"] = "Organization";
    ResourceType["SITE"] = "Site";
    ResourceType["SPACE"] = "Space";
    ResourceType["EQUIPMENT"] = "Equipment";
    ResourceType["GATEWAY"] = "Gateway";
    ResourceType["HUB"] = "Hub";
    ResourceType["CONTROLBOARD"] = "Control Board";
    ResourceType["SENSOR"] = "Sensor";
    ResourceType["SITEGROUP"] = "Site Group";
    ResourceType["FIRMWARE"] = "Firmware";
    ResourceType["DISTRIBUTIONPANEL"] = "Distribution Panel";
    ResourceType["BREAKER"] = "Circuit Breaker";
    ResourceType["ENERGYPRO"] = "Energy Pro";
    ResourceType["ENERGYBAR"] = "Energy Bar";
    ResourceType["ENERGYSPIDER"] = "Energy Spider";
    ResourceType["ENERGYSPIDERFLEX"] = "Energy Spider Flex";
    ResourceType["NETWORKGROUP"] = "Network Group";
    ResourceType["SOP"] = "SOP";
    ResourceType["ACTUATOR"] = "Actuator";
    ResourceType["VENSTARTHERMOSTAT"] = "Venstar Thermostat";
    ResourceType["ENERGYBOXTHERMOSTAT"] = "Energybox Thermostat";
    ResourceType["EDGE"] = "Edge";
})(ResourceType || (ResourceType = {}));
export var ResourceEntity;
(function (ResourceEntity) {
    ResourceEntity["EQUIPMENT_GROUP"] = "EquipmentGroup";
    ResourceEntity["EQUIPMENT_TYPE"] = "EquipmentType";
    ResourceEntity["EQUIPMENT"] = "Equipment";
})(ResourceEntity || (ResourceEntity = {}));
